// components/advertiser-wallet/StatCard.tsx
import React from "react";

interface StatCardProps {
  icon: React.ReactNode;
  label: string;
  value: string;
  helper: string;
  valueClassName?: string;
}

const StatCard: React.FC<StatCardProps> = ({ icon, label, value, helper, valueClassName }) => (
  <div className="bg-white rounded-2xl border border-gray-100 p-4 sm:p-5 flex flex-col gap-3 min-w-0">
    <div className="w-8 h-8 rounded-lg bg-gray-50 flex items-center justify-center text-gray-500">
      {icon}
    </div>
    <div>
      <p className="text-sm text-gray-500">{label}</p>
      <p className={`text-xl sm:text-2xl font-semibold text-black mt-1 ${valueClassName ?? ""}`}>
        {value}
      </p>
      <p className="text-xs text-gray-400 mt-1">{helper}</p>
    </div>
  </div>
);

export default StatCard;